import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Privacy from './components/Privacy'
import Disclaimer from './components/Disclaimer'
import Contact from './components/Contact'


// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueRouter)


Vue.config.productionTip = false


const routes = [
  { path: '/privacy', component: Privacy },
  { path: '/disclaimer', component: Disclaimer },
  { path: '/contact', component: Contact },

]


const router = new VueRouter({
  routes: routes
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
